import {
  GET_MICRO_LOANS_SETTINGS_ERROR,
  GET_MICRO_LOANS_SETTINGS_START,
  GET_MICRO_LOANS_SETTINGS_SUCCESS,
} from 'constants/action-types/settings/getMicroLoansSettingData';

export default (state, { type, payload }) => {
  switch (type) {
    case GET_MICRO_LOANS_SETTINGS_START:
      return {
        ...state,
        microloanSettings: {
          ...state.microloanSettings,
          loading: true,
          error: null,
          data: {},
        },
      };
    case GET_MICRO_LOANS_SETTINGS_ERROR:
      return {
        ...state,
        microloanSettings: {
          ...state.microloanSettings,
          error: payload,
          loading: false,
        },
      };
    case GET_MICRO_LOANS_SETTINGS_SUCCESS:
      return {
        ...state,
        microloanSettings: {
          ...state.microloanSettings,
          data: payload,
          loading: false,
        },
      };
    default:
      return null;
  }
};
